import { defaultFont } from "assets/jss/material-dashboard-pro-react.js";

import customDropdownStyle from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.js";

const adminNavbarLinksStyle = theme => ({
	...customDropdownStyle(theme),
	linkText: {
		zIndex: "4",
		...defaultFont,
		fontSize: "14px",
		margin: "0!important",
		textTransform: "none"
	},
	buttonMenuListClasses: {
		[theme.breakpoints.up("md")]: {
			display: "inline-block"
		}
	},
	buttonMenuLink: {
		[theme.breakpoints.down("sm")]: {
			display: "flex",
			margin: "5px 15px 0",
			width: "auto",
			height: "auto",
			"& svg": {
				width: "30px",
				height: "24px",
				marginRight: "19px",
				marginLeft: "3px"
			},
			"& .fab,& .fas,& .far,& .fal,& .material-icons": {
				width: "30px",
				fontSize: "24px",
				lineHeight: "30px",
				marginRight: "19px",
				marginLeft: "3px"
			}
		}
	},
	links: {
		width: "20px",
		height: "20px",
		zIndex: "4",
		[theme.breakpoints.down("sm")]: {
			display: "block",
			width: "30px",
			height: "30px",
			color: "inherit",
			opacity: "0.8",
			marginRight: "16px",
			marginLeft: "-5px"
		}
	},
	headerLinksSvg: {
		width: "20px !important",
		height: "20px !important"
	}
});

export default adminNavbarLinksStyle;
